<template>
  <div>
    <b-card title="گردش کیف پول ریالی">
      <!-- start modal for settelment request -->
      <b-modal id="modal-2" title="درخواست تسویه">
        <b-form-group label="شماره شبا:">
          <b-form-select v-model="selected" :options="options"></b-form-select>
        </b-form-group>
        <b-form-group label="مبلغ (سقف مبلغ 1,000,000,000 ریال):">
          <NumberSeprator v-model="amount" id="tt"></NumberSeprator>
        </b-form-group>
        <template #modal-footer>
          <div class="">
            <b-button size="md" class="float-right" @click="cancel">
              انصراف
            </b-button>
          </div>
          <div class="">
            <b-button
              variant="primary"
              size="md"
              class="float-right"
              @click="SendCheckout"
            >
              درخواست تسویه
            </b-button>
          </div>
        </template>
      </b-modal>
      <!-- end modal for settelment request -->
      <b-row align-v="center">
        <b-col cols="3">
          <b-form-group label="موجودی:">
            <div class="form-control">
              {{ deposite!= null ? Number(deposite).toLocaleString() : "" }}
            </div>
          </b-form-group>
        </b-col>
        <b-col cols="3">
          <b-button
            @click="$bvModal.show('modal-2')"
            class="btn btn-success font-weight-bold text-uppercase"
            data-wizard-type="action-submit"
            >درخواست تسویه</b-button
          >
        </b-col>
      </b-row>
      <div v-if="!dataLoaded">
        <b-row>
          <b-col cols="3">
            <b-form-group label="درگاه">
              <b-skeleton type="button" width="100%" class="mb-3"></b-skeleton>
            </b-form-group>
          </b-col>
        </b-row>

        <b-skeleton-table
          :rows="10"
          :columns="7"
          :table-props="{ bordered: true, striped: true }"
        ></b-skeleton-table>
      </div>
      <div v-if="dataLoaded">
        <b-row align-v="center">
          <b-col cols="3">
            <b-form-group label="موجودی:">
              <div class="form-control">
                {{ transactions[0].Total.toLocaleString() }} ریال
              </div>
            </b-form-group>
          </b-col>
          <b-col cols="3">
            <b-button
              @click="$bvModal.show('modal-2')"
              class="btn btn-success font-weight-bold text-uppercase"
              data-wizard-type="action-submit"
              >درخواست تسویه</b-button
            >
          </b-col>
        </b-row>
        <!-- start modal for settelment request -->
        <b-modal id="modal-2" title="درخواست تسویه">
          <b-form-group label="شماره شبا:">
            <b-form-select
              v-model="selected"
              :options="options"
            ></b-form-select>
          </b-form-group>
          <b-form-group label="مبلغ (سقف مبلغ 1,000,000,000 ریال):">
            <NumberSeprator v-model="amount" id="tt"></NumberSeprator>
          </b-form-group>
          <template #modal-footer>
            <div class="">
              <b-button size="md" class="float-right" @click="cancel">
                انصراف
              </b-button>
            </div>
            <div class="">
              <b-button
                variant="primary"
                size="md"
                class="float-right"
                :disabled="checkoutDisable"
                @click="SendCheckout"
              >
                درخواست تسویه
              </b-button>
            </div>
          </template>
        </b-modal>
        <!-- end modal for settelment request -->
        <TableShowData
          :url="url"
          :fields="fields"
          :params="params"
          :excelroute="'excelroute'"
        >
        </TableShowData>
      </div>
    </b-card>
  </div>
</template>
<script>
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import {
  GET_USER_CARD_LIST,
  SEND_CHECKOUT_REQUEST,
  SEND_CHECKOUT_REQUEST_IR_WALLET,
} from "@/core/services/store/mypurcent.module";
import TableShowData from "@/components/table.vue";

import httpHelper from "../../helpers/httpHelper";
import persianDate from "../../helpers/persianDate";

import NumberSeprator from "@/components/numberSeprator";

export default {
  name: "irWalletTrans",
  data() {
    return {
      amount: 0,
      dataLoaded: false,
      gateway_id: null,
      gateways: [],
      transactions: [],
      pages: [],
      current_page: 1,
      page_count: 0,
      deposite: null,
      fields: [
        {
          key: "created_at",
          label: "تاریخ",
        },
        {
          key: "website_name",
          label: "وبسایت",
        },
        {
          key: "transaction_id",
          label: "شماره تراکنش",
        },
        {
          key: "des",
          label: "توضیحات",
          formatter(value, key, item) {
            if (item.ttalWithoutKarmozd <= 0) {
              return "برداشت وجه و انتقال برای تسویه";
            } else {
              return (
                "واریز مبلغ " +
                Number(item.cost).toLocaleString() +
                " " +
                item.money_type
              );
            }
          },
        },
        {
          key: "ttalWithoutKarmozd",
          label: " مبلغ بدون احتساب کامزد (ریال)",
          formatter(value, key, item) {
            return item.cost != null
              ? Number(item.cost).toLocaleString() + " " + item.money_type
              : item.ttalWithoutKarmozd + " ریال";
          },
          tdClass: (value, key, item) => {
            return item.ttalWithoutKarmozd > 0 ? "text-success" : "text-danger";
          },
        },
        {
          key: "karmozd",
          label: " کارمزد (ریال)",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
        {
          key: "status",
          label: "وضعیت",
          formatter(value, key, item) {
            return item.ttalWithoutKarmozd < 0 && item.tracking_number == null
              ? "در دست بررسی"
              : item.ttalWithoutKarmozd < 0 && item.tracking_number != null
              ? item.tracking_number
              : "";
          },
          tdClass: (value, key, item) => {
            return item.ttalWithoutKarmozd > 0 ? "text-success" : "text-danger";
          },
        },
        {
          key: "Total",
          label: "موجودی (ریال) ",
          formatter(value, key, item) {
            return Number(value).toLocaleString();
          },
        },
      ],
      selected: null,
      options: [],
      checkoutDisable: false,
      url: "irwalletTransactions/" + this.$route.params.id ,
      params: [
        {
          label: "درگاه:",
          field: "gateways",
          type: "select",
          options: [],
        }
      ],
    };
  },
  components: {
    NumberSeprator,
    TableShowData
  },
  watch: {},
  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [{ title: "گردش کیف پول ریالی" }]);
    this.LoadData(1);
    this.loadMerchants();
    this.getUserCardList();
    this.loadDeposite();
  },
  methods: {
    loadDeposite() {
      httpHelper
        .getData("/irwallets?walletid=" + this.$route.params.id)
        .then((res) => {
          this.deposite = res.result[0].ENmojudi;
        });
    },
    getDate(date) {
      var d = new Date(date);
      return (
        persianDate.getDateByFormat(date) +
        " " +
        d.getHours() +
        ":" +
        d.getMinutes()
      );
    },
    loadMerchants() {
      httpHelper.getData("paymentgateways").then((res) => {
        this.params[0].options = res.result
          .filter((o) => {
            return o.mdid12_money_type != 1722;
          })
          .map((o) => {
            return {
              text: o.website_name,
              value: o.id,
            };
          });
      });
    },
    createPager(last_page, current_page) {
      this.pages = [];
      this.current_page = current_page;
      var startPageer = this.current_page > 5 ? this.current_page - 4 : 0;
      var endPageer = last_page > 5 ? this.current_page + 3 : last_page;
      this.page_count = last_page;
      if (this.current_page + 3 > this.page_count) {
        endPageer = this.page_count;
      }
      for (let i = startPageer; i < endPageer; i++) {
        this.pages.push(i + 1);
      }
    },
    LoadData(page) {
      this.dataLoaded = false;
      var url =
        "irwalletTransactions/" + this.$route.params.id + "?page=" + page;
      if (this.gateway_id != null) {
        url += "&gateway_id=" + this.gateway_id;
      }
      httpHelper.getData(url).then((res) => {
        this.dataLoaded = true;
        this.transactions = res.result.data;
        // this.pages = [];
        // this.current_page = res.result.current_page;
        // for (let i = 0; i < res.result.last_page; i++) {
        //   this.pages.push(i + 1);
        // }
        this.createPager(res.result.last_page, res.result.current_page);
      });
    },
    getUserCardList() {
      // this.show = true;
      let obj = {};
      this.$store.dispatch(GET_USER_CARD_LIST).then((data) => {
        data.result.forEach((element) => {
          if (element.is_default === 1 && element.is_business_partners === 0) {
            this.selected = element.id;
          }
          if (element.is_business_partners === 0) {
            Object.assign(obj, {
              value: element.id,
              text: element.nickname + " " + element.shaba_number,
            });

            this.options.push(obj);
            obj = {};
          }
        });
      });
    },
    SendCheckout() {
      if (this.selected != null && this.amount <= 1000000000) {
        let obj = {};
        Object.assign(obj, {
          id: this.$route.params.id,
          amount: this.amount,
          user_card_id: this.selected,
        });
        this.$store
          .dispatch(SEND_CHECKOUT_REQUEST_IR_WALLET, obj)
          .then((data) => {
            this.checkoutDisable = true
            if (data.message === "success") {
              this.show = false;
              this.$makeToast(
                "success",
                "تسویه موفق",
                "درخواست تسویه با موفقیت ثبت گردید.",
                5000
              );
              this.LoadData(1);
            }
          })
          .finally(() => {
          this.checkoutDisable = false;
        });
      } else {
        this.selected == null
          ? this.$makeToast(
              "danger",
              "خطا",
              "لطفا شماره شبای خود رو انتخاب کنید.",
              5000
            )
          : this.$makeToast(
              "danger",
              "خطا",
              "مبلغ وارد شده بیشتر از سقف مجاز 1,000,000,000 ریال می باشد.",
              5000
            );
      }
    },
    cancel() {
      this.$bvModal.hide("modal-2");
    },
  },
};
</script>